/**
 * Uzbekistani soʻm.
 */
export var UZS = {
  code: 'UZS',
  base: 10,
  exponent: 2
};